<sirius-grid>
    @if (title) {
        <sirius-heading [text]="title" [h]="2" textStyleSize="m" data-cy="table-group-title"></sirius-heading>
        <!-- @if (subTitle) {
            <h3 data-cy="grid-subtitle">{{ subTitle }}</h3>
        } -->
    }
    @if (subTitle) {
        <sirius-heading
            class="sir-subtitle-heading"
            [text]="subTitle"
            [h]="3"
            textStyleSize="xs"
            data-cy="table-group-subtitle"></sirius-heading>
    }
    @if (tables.length) {
        <div class="sir-container">
            @for (table of tables; track $index) {
                <sirius-table [rows]="table.rows" [title]="table.title"></sirius-table>
            }
        </div>
    }
</sirius-grid>
